import './styling.scss';
import * as template from './template.html';
import { getOverviewSref } from 'components/navigation/shared/states';
import * as policiesPolicyHistoryCard from '../policies-policy-history-card';
import * as angular from 'angular';

const module = angular.module('policies-previous-policies-section', [policiesPolicyHistoryCard.module.name]);

interface PoliciesPageController extends angular.IStrictController {
    mode: 'page' | 'section';
    policyInfosWithIndexes: Array<CustomerPolicyInfoWithIndex>;
    getPolicySref: typeof getOverviewSref;
    shouldDisplayAsPage(): boolean;
    shouldDisplayAsSection(): boolean;
}

module.component('policiesHistorySection', {
    template: template,
    bindings: {
        policyInfosWithIndexes: '<',
        mode: '='
    },
    controller: function(this: PoliciesPageController) {
        this.$onInit = () => {
            this.getPolicySref = getOverviewSref;

            this.shouldDisplayAsPage = function() {
                return this.mode === 'page';
            };

            this.shouldDisplayAsSection = function() {
                return this.mode === 'section';
            };
        };
    }
});

export { module };
